import { useMemo } from 'react';
import {
	SOFTWARE_PROJECT,
	toProjectType,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import {
	type ApplicationEditions,
	STANDARD_EDITION,
} from '@atlassian/jira-shared-types/src/edition.tsx';

export const isProjectTypeAndEditionSupported = (
	applicationEditions: ApplicationEditions,
	project?: string,
): Boolean => {
	const projectType = toProjectType(project);

	if (!projectType || projectType !== SOFTWARE_PROJECT) {
		return false;
	}

	return applicationEditions.software === STANDARD_EDITION;
};

const getStartOfUTCDay = (timestamp: number) => new Date(timestamp).setUTCHours(0, 0, 0, 0);

const getTrialDaysLeft = (currentDate: number, trialEndTime?: number | null): number | undefined =>
	trialEndTime
		? Math.ceil((getStartOfUTCDay(trialEndTime) - currentDate) / (24 * 3600 * 1000))
		: undefined;

export const useTrialDaysLeft = (trialEndTime?: number): number => {
	const currentDate = useMemo(() => Date.now(), []);
	const trialDaysLeft = getTrialDaysLeft(currentDate, trialEndTime) ?? 0;

	return trialDaysLeft;
};

/**
 * Returns wether or not the current day of a given trial is
 * during the supported date range for this experiment
 */
export const isStartOfTrial = (daysLeft: number): boolean => daysLeft >= 8 && daysLeft <= 13;

export const getEpMessageId = (daysLeft: number): string | null => {
	if (daysLeft >= 11 && daysLeft <= 13) {
		return 'prj-end-of-trial-extension-message-1';
	}

	if (daysLeft >= 8 && daysLeft <= 10) {
		return 'prj-end-of-trial-extension-message-2';
	}

	return null;
};
